/**
 * @deprecated use TableV2 and its subcomponents from '@frontend/legacy-components' instead.
 */
const constants = {
  emptyFilterState: '',
  emptySortDirection: null,
  emptySortPriority: 0,
  possibleSortDirections: ['ascending', 'descending'],
  emptyPossibleSortDirections: [],
  ascendingIdentifier: 'ascending',
  descendingIdentifier: 'descending',
  selection: {
    disabled: 'disabled',
    hidden: 'hidden',
  },
};

export default constants;
